import { loader } from 'graphql.macro'

export default async function createClientImport ({ dataLoaders, variables }) {
  const schema = loader('./createClientImport.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      signedId: variables.signedId
    }
  })
  return response.createClientImport
}
